<script>
	import { createEventDispatcher, onDestroy } from 'svelte';

	const dispatch = createEventDispatcher();
	const close = () => dispatch('close');

	let modal;

	const handle_keydown = e => {
		if (e.key === 'Escape') {
			close();
			return;
		}

		if (e.key === 'Tab') {
			// trap focus
			const nodes = modal.querySelectorAll('*');
			const tabbable = Array.from(nodes).filter(n => n.tabIndex >= 0);

			let index = tabbable.indexOf(document.activeElement);
			if (index === -1 && e.shiftKey) index = 0;

			index += tabbable.length + (e.shiftKey ? -1 : 1);
			index %= tabbable.length;

			tabbable[index].focus();
			e.preventDefault();
		}
	};

	const previously_focused = typeof document !== 'undefined' && document.activeElement;

	if (previously_focused) {
		onDestroy(() => {
			previously_focused.focus();
		});
	}
</script>

<svelte:window on:keydown={handle_keydown}/>

<div class="modal-background" on:click={close}></div>

<div class="modal" role="dialog" aria-modal="true" bind:this={modal}>
	<slot name="header"></slot>
    <slot></slot>
    <slot class="footer" name="footer"></slot>
</div>

<style>

	.modal-background {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 900;
	}

	.modal {
        position: fixed;
        z-index: 1000;
		left: 0;
		right: 0;
		margin: auto;
		top: 50px;
		width: calc(100vw - 4em);
		max-width: 600px;
		border-radius: 6px;
        background: #F8F8F8;
        padding: 50px;
        text-align: center;
        font-size: 18px;
        color: #747474;
        overflow: hidden;
    }

    .modal :global(.modal-subtitle){
    	display: block;
    	font-size: 22px;
    	font-weight: 300;
    	margin: 15px 0 40px;
   } 

    .modal :global(h2){
        color: #464646;
        line-height: 42px;
    }

    .modal :global(.modal-rules){
    	display: block;
    	font-size: 14px;
    	width: 75%;
    	text-align: left;
    	margin: auto;
    	margin-top: 15px;
    }

    .modal :global(label){
    	display: block;
    	font-size: 14px;
    	width: 75%;
    	text-align: left;
    	margin: auto;
    	margin-top: 8px;
        cursor: pointer;
    }

    .modal :global(.im-input){
		padding: 17.5px;
	    border-radius: 4px;
	    font-size: 16px;
	    width: 75%;
	    transition: all 300ms ease-in-out;
	    border: 2px solid #E8E8E8;
	    color: #747474;
    }

    .modal :global(.im-input:focus){
		border-color: #d2d2d2;
    }

    .modal :global(.false-link){
		cursor: pointer;
		transition: all 300ms ease;
		color: #f8b58b;
    }

    .modal :global(.false-link:hover){
    	opacity: 0.7;
    }

    .modal :global(.im-input::placeholder){
		color: #c4c4c4;
    }

    .modal :global(.modal-snowflakes){
    	margin: 40px 0 20px;
        display: block;
        font-size: 21px;
    }

    .modal :global(.btn){
        display: inline-block;
        margin-top: 15px;
        width: 75%;
        font-size: 22px;
    }

    .modal :global(.sprite-pms-gift-yellow-medium){
		width: 135px;
		height: 158px;
		background-position: -70px 0;
		background-size: 420px 280px;
		position: absolute;
	    left: -28px;
	    bottom: -36px;
	    transform: rotate(6deg);
        z-index: 10;
	}

    .modal :global(p) {
        opacity: 0.8;
        font-size: 18px;
    }

    .modal :global(.modal-footer) {
    	border-top: 1px solid #E3E3E3;
        font-size: 16px;
        padding-top: 20px;
    	margin: 40px auto 0px;
        color: #f8b58b;
        text-decoration: none;
        display: block;
        width: 75%;
    }

    .modal :global(input[type="checkbox"]){
    	position: relative;
    	top: 2px;
    }

    @media screen and (max-width: 992px) {
        .modal {
            position: fixed;
            top: 30px;
            width: calc(100% - 20px);
            padding: 30px;
            max-height: 470px;
            overflow: scroll;
        }

        .modal :global(.btn){
            font-size: 20px;
        }

        .modal :global(.btn), .modal :global(.modal-footer), .modal :global(.im-input), .modal :global(.modal-rules), .modal :global(label){
            width: 100%;
        }

        .modal :global(.sprite-pms-gift-yellow-medium){
            display: none;
        }

        .modal :global(h2){
            font-size: 34px;
            line-height: 38px;
        }

        .modal :global(.modal-subtitle){
            font-size: 20px;
            margin: 15px 0 30px;
       } 
    }
</style>
